import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { DashboardPathName, DashboardRoute } from '@/modules/ta/dashboard/dashboard.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${DashboardRoute.MANAGE_LEADS}`,
      name: DashboardPathName.MANAGE_LEADS,
      component: () =>
        import(
          /* webpackChunkName: "leads-manage-page" */ '@/modules/ta/lead/pages/LeadsManagePage.vue'
        ),
    },
    {
      path: `/${DashboardRoute.LEADS}/:leadId`,
      name: DashboardPathName.LEADS_EDIT,
      component: () =>
        import(
          /* webpackChunkName: "leads-edit-page" */ '@/modules/ta/lead/pages/LeadFormPage.vue'
        ),
    },
  ],
  Module.LEAD
);
